<template>
  <div id="app">
    <section id="topSection"
             class="hero-area overlay">

      <div class="block"
           id="nameBox">
        <h1 class="nameHeader">
          <span style="color: #1594f3 !important">alex</span>gignilliat
        </h1>
        <p data-aos="fade-in"
           class="tagline"
           style="letter-spacing: 4px">
          <span style="color: #1594f3 !important; letter-spacing: 4px">
            Full Stack Developer
          </span>
        </p>
        <br />
        <a data-scroll
           href="#about"
           class=""><button style="border-radius: 0px; min-width: 10%"
                  class="btn portfolioButton hvr-underline-from-left">
            <span style="color: #1594f3 !important">About </span> Me
          </button></a>
      </div>
    </section>
    <section class="sectionDiv"
             id="about"
             style="height: 100vh; background-color: #171c21; padding-top: 15%">


      <h2 data-aos-easing="ease-in-out"
          data-aos-duration="500"
          data-aos="fade-in"
          style="color: white">
        Specialize in developing
        <span style="color: #1594f3">
          clean user interfaces & seamless user experiences</span>.
      </h2>
      <h2 data-aos-easing="ease-in-out"
          data-aos-duration="500"
          data-aos="fade-in"
          style="color: white"
          data-aos-delay="500">
        Passionate about the role of
        <span style="color: #1594f3"> web apps in financial technology, AI & Web3</span>.
      </h2>
      <h2 data-aos-easing="ease-in-out"
          data-aos-duration="500"
          data-aos="fade-in"
          style="color: white"
          data-aos-delay="1000">
        Obsessed with
        <span style="color: #1594f3"> continuous learning, solving problems... and coffee</span>.
      </h2>
      <a data-scroll
         href="#technologies"
         class=""
         data-aos-easing="ease-in-out"
         data-aos-duration="1000"
         data-aos="fade-in"
         style="color: white"
         data-aos-delay="1500"><button style="border-radius: 0px; min-width: 10%"
                class="btn portfolioButton hvr-underline-from-left">
          Technologies I Use
        </button></a>
    </section>

    <Technologies />

    <MyWork />




  </div>
</template>

<script>
import "bootstrap/dist/css/bootstrap.css";
import "bootstrap/dist/css/bootstrap.css";
import "bootstrap-vue/dist/bootstrap-vue.css"; import AOS from "aos";
import "aos/dist/aos.css";

// const PortfolioCard = () => import('./components/PortfolioCard.vue')
const Technologies = () => import("./components/Technologies.vue")
const MyWork = () => import("./components/MyWork.vue")



export default {
  props: {
    test: String
  },
  components: { Technologies, MyWork },
  created() {
    AOS.init();
    document.title = "Alex Gignilliat";
    console.log(
      "%c “The Times 03/Jan/2009 Chancellor on brink of second bailout for banks.” ",
      "background: #222; color: #bada55"
    );
  },

  data() {
    return {
      introHeader: "",
      colorVanta: "rgb(24, 154, 243)",
      backgroundColorVanta: "red",
      options: {
        mouseControls: true,
        touchControls: true,
        minHeight: 500.00,
        minWidth: 200.00,
        scale: 1.00,
        scaleMobile: 1.00
      },
      //         gyroControls: false,
      // minHeight: 900.0,
      // minWidth: 100.0,
      // scale: 1.0,
      // scaleMobile: 1.0,
      // points: 5.0,
      // spacing: 18.0,
      // color: "#1594f3",
      // backgroundColor: "#171C21",
      methods: {
        headerChange: function () {
          this.introHeader = "hehrhsdjkfhs";
        },
      },

    };
  },

  name: "App",
};
</script>

<style>
@import url("https://fonts.googleapis.com/css2?family=Inter:wght@300&display=swap");


html {
  scroll-behavior: smooth;
  max-width: 100%;
  background-color: #171c21;
}

#techTop {
  padding-top: 55px;
}

.techH1 {
  color: #1594f3;
  text-align: left;
  margin: 20px
}


.blueSpan {
  color: #1594f3;
}

#about {
  padding: 50px;
}

@media only screen and (max-width: 600px) {

  .portfolioCard {
    padding-bottom: 100px;

  }

  html,
  body {
    background-color: #171c21;
    padding: 0;
  }

  #techTop {
    padding-top: 0px;
  }

  .techH1 {
    text-align: center;
  }

  #vanta {
    margin-bottom: 10%;
  }


  #projectHeader {
    font-size: 80px !important;
  }

  .sectionDiv {
    padding: 20px 10px;
    margin-top: 10%;
    z-index: 100;
  }

  #technologies {
    margin: 0;
    margin-bottom: 10%;
    height: 120vh;
    background-color: #171c21;
    padding-top: 1% !important;
  }

  h1 {
    text-align: center;
  }

  #portfolio {
    margin-top: 1000px;
    margin-bottom: 800px;
    padding-bottom: 500px;
  }

  /* h1 {
    font-size: 40px !important;
  } */

  h2 {
    font-size: 20px;
    margin: 10%;
  }

  .tagline {
    font-size: 20px !important;
  }

  .fa-js,
  .fa-node,
  .fa-vuejs {
    font-size: 100px !important;
    text-align: center;
    display: inline-block;
    justify-content: center;
  }

  .technologyHeaders {
    padding: 10px;
  }

  #techLine {
    border-top: 1px solid white;
  }

  #topSection {
    position: relative;
    top: -100px;
  }

  #about {
    margin-top: 20%;
  }


  #contact {
    margin-bottom: 10%;
    margin-top: 500px;
    height: 80vh;
  }
}

h1 {
  font-weight: 100;
}

@media only screen and (max-width: 360px) {
  #portfolio {
    margin-top: 1000px;
    margin-bottom: 1000px;
  }

  #contact {
    height: 87vh;
  }
}

body {
  padding: 0;
  margin: 0;
  scroll-behavior: smooth;
  max-width: 100%;
}

.portfolioImg {
  width: 100%;
  margin: 0 auto;
  max-width: 450px;
  box-shadow: 0px 0px 8px rgba(255, 255, 255, 0.322);
  border: 1px solid rgb(255, 255, 255);
  padding: 1px;
}

.portfolioH1 {
  color: #1594f3;
  ;
  font-size: 3rem;
  margin: 1%;
  text-align: left;
}

.cardDark {
  background-color: #000000;

}



.cardLight {
  background-color: #37373a;

}

.portfolioCard {

  width: 100%;
  display: flex;
  justify-content: center;
  padding: 40px;

}

#nameBox {
  background: rgba(255, 255, 255, 0.13);
  box-shadow: 10px 10px 10px rgba(221, 213, 213, 0.014);
  backdrop-filter: blur(10px);
  -webkit-backdrop-filter: blur(1px);
  border-radius: 5px;
  width: 100%;
  /* border-radius: 22px; */
  border: 3px solid rgba(255, 255, 255, 0.116);
  background-clip: padding-box;
  padding: 15px;

  border-top: 3px rgba(255, 255, 255, 0.199) solid;
}

#app {
  font-family: "Inter", sans-serif;

  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  width: 100%;
  background-color: #171c21;
  height: 100vh;
}

.portfolioButton {
  background-color: rgba(255, 255, 255, 0.788);
  margin: 30px;
  font-weight: bold;
  font-size: 18px;
  text-shadow: 0px 0px 2px rgba(165, 165, 165, 0.212);
  border: 1px solid rgba(255, 255, 255, 0.192);
}

.portfolioButton:hover {
  background-color: rgb(255, 255, 255);
  box-shadow: 0px 0px 10px rgba(255, 255, 255, 0.205);
}

.hero-area {
  background-size: cover;
  height: 100vh;
  position: relative;
  display: flex;
  justify-content: center;
  align-items: center;
  overflow: hidden;
}

.hero-area .block {
  text-align: center;
  z-index: 99;
}

.hero-area .block .video-button a {
  background: #fff;
  display: inline-block;
  height: 60px;
  width: 60px;
  border-radius: 50px;
  line-height: 60px;
  font-size: 20px;
  margin-left: 3px;
  color: #57cbcc;
}

.hero-area .block h1 {
  font-size: 70px;
  color: #fff;
  /* text-transform: capitalize; */
  font-weight: 100;
  margin-bottom: 20px;
}

.hero-area .block p {
  color: #fff;
  font-size: 20px;
  width: 70%;
  margin: 0 auto;
}

.hero-area .block .btn-transparent {
  margin-top: 40px;
  border-color: #fff;
  padding: 14px 50px;
  font-size: 18px;
  font-size: 16px;
  font-weight: bold;
  letter-spacing: 1px;
}

.hero-video {
  left: 50%;
  min-height: 100%;
  min-width: 100%;
  position: absolute;
  top: 50%;
  -webkit-transform: translate(-50%, -50%);
  transform: translate(-50%, -50%);
}

.hvr-underline-from-left {
  display: inline-block;
  vertical-align: middle;
  -webkit-transform: perspective(1px) translateZ(0);
  transform: perspective(1px) translateZ(0);
  box-shadow: 0 0 1px rgba(0, 0, 0, 0);
  position: relative;
  overflow: hidden;
}

.hvr-underline-from-left:before {
  content: "";
  position: absolute;
  z-index: -1;
  left: 0;
  right: 100%;
  bottom: 0;
  background: #1494f3;
  height: 4px;
  -webkit-transition-property: right;
  transition-property: right;
  -webkit-transition-duration: 0.3s;
  transition-duration: 0.3s;
  -webkit-transition-timing-function: ease-out;
  transition-timing-function: ease-out;
}

.hvr-underline-from-left:hover:before,
.hvr-underline-from-left:focus:before,
.hvr-underline-from-left:active:before {
  right: 0;
}

@media (max-width: 480px) {
  .hero-area .block h1 {
    font-size: 60px;
  }
}

h1 {
  margin: 0;
  color: white;
}
</style>
